var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', {
    scopedSlots: _vm._u([{
      key: "subHead",
      fn: function fn() {
        return [_c('sub-visual', {
          attrs: {
            "title": "유통데이터 활용 경진대회 주요자료",
            "src": "/images/sub/sub-visual-circulation.jpg"
          }
        })];
      },
      proxy: true
    }])
  }, [_c('page-section', {
    staticClass: "page-section--first page-section--last"
  }, [_c('div', {
    staticClass: "tab-wrap",
    attrs: {
      "data-aos": "fade-right",
      "data-aos-delay": "100"
    }
  }, [_c('u-tabs', _vm._l(_vm.categories, function (category, index) {
    return _c('u-tab', {
      key: index,
      on: {
        "click": function click($event) {
          _vm.filter.category = category, _vm.search(true);
        }
      }
    }, [_vm._v(" " + _vm._s(category) + " ")]);
  }), 1)], 1), _c('v-divider', {
    staticClass: "grey darken-4 mb-20px mb-md-32px",
    staticStyle: {
      "border-width": "2px 0 0"
    }
  }), _c('v-row', {
    attrs: {
      "data-aos": "fade-up",
      "data-aos-delay": "200"
    }
  }, _vm._l(_vm.datas, function (data) {
    return _c('v-col', {
      key: data._id,
      attrs: {
        "cols": "6",
        "md": "4"
      }
    }, [_c('card-board', {
      attrs: {
        "to": "/circulation/data/".concat(data._id),
        "chip": data === null || data === void 0 ? void 0 : data.awardName,
        "title": data === null || data === void 0 ? void 0 : data.subject,
        "teamName": data === null || data === void 0 ? void 0 : data.name,
        "view": String(data === null || data === void 0 ? void 0 : data.viewCount)
      }
    })], 1);
  }), 1), _c('div', {
    staticClass: "v-pagination-wrap"
  }, [_c('v-pagination', {
    attrs: {
      "length": _vm.pageCount,
      "total-visible": "11"
    },
    on: {
      "input": function input($event) {
        return _vm.search(true);
      }
    },
    model: {
      value: _vm.page,
      callback: function callback($$v) {
        _vm.page = $$v;
      },
      expression: "page"
    }
  })], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }